// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Table main design */
.custom-table {
  width: auto;
  background-color: white;
  border-collapse: collapse;
  font-family: 'Lato', sans-serif  !important;
  border-radius: 8px;
  /* box-shadow: 0px 2px 8px lightgray; */
}

/* Long unbreakable strings (URLs, ids) shouldn't force the table wider
   than needed — wrap them instead of inflating the column. */
.custom-table td {
  overflow-wrap: anywhere;
}

.custom-table thead th {
  position: static !important;
}

.table-border {

  border-right: 1px solid rgb(222, 219, 219);   
  
}

.table-border:last-child {
  border: none;
}

.product-image {
  margin-left: 20px;   /* left se space */
}

/* Table header background */
.custom-table thead {
  background-color: #fafafa;
}

/* Header text */
.custom-table th {
  padding: 10px 14px;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  color: #262626;
  border-bottom: 1px solid #f0f0f0;
  /* Shrink every column to its content's width instead of letting
     auto table layout hand unused space to columns that don't need it. */
  width: 1%;
  white-space: nowrap;
}

/* Table data */
.custom-table td {
  padding: 8px 14px;
  font-size: 13px;
  color: #595959;
  border-bottom: 1px solid #f0f0f0;
  width: 1%;
}

/* Row hover effect */
.custom-table tr:hover {
  background-color: #e6f7ff;
}

/* Even row color */
.custom-table tr:nth-child(even) {
  background-color: #fcfcfc;
}

/* Pagination button */
.page_link_item {
  background-color: white;
  border: 1px solid #d9d9d9;
  padding: 5px 10px;
  margin: 3px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

/* Pagination hover */
.page_link_item:hover {
  color: #1890ff;
  border-color: #1890ff;
}

/* Disabled button */
.page_link_item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Input box */
.page_link_item input {
  border: 1px solid #d9d9d9;
  padding: 3px;
  border-radius: 4px;
}

/* Select box */
.page_link_item select {
  border: 1px solid #d9d9d9;
  padding: 3px;
  border-radius: 4px;
}

/* Pagination margin */
.my-3 {
  margin-top: 15px;
}

/* Mobile screen */
@media (max-width: 768px) {

  .custom-table {
    font-size: 12px;
  }

  .custom-table th,
  .custom-table td {
    padding: 8px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/table.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;6DAC6D;AAC7D;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,0CAA0C;;AAE5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB,IAAI,kBAAkB;AACzC;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC;yEACuE;EACvE,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;;EAEE;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;AAEF","sourcesContent":["/* Table main design */\n.custom-table {\n  width: auto;\n  background-color: white;\n  border-collapse: collapse;\n  font-family: 'Lato', sans-serif  !important;\n  border-radius: 8px;\n  /* box-shadow: 0px 2px 8px lightgray; */\n}\n\n/* Long unbreakable strings (URLs, ids) shouldn't force the table wider\n   than needed — wrap them instead of inflating the column. */\n.custom-table td {\n  overflow-wrap: anywhere;\n}\n\n.custom-table thead th {\n  position: static !important;\n}\n\n.table-border {\n\n  border-right: 1px solid rgb(222, 219, 219);   \n  \n}\n\n.table-border:last-child {\n  border: none;\n}\n\n.product-image {\n  margin-left: 20px;   /* left se space */\n}\n\n/* Table header background */\n.custom-table thead {\n  background-color: #fafafa;\n}\n\n/* Header text */\n.custom-table th {\n  padding: 10px 14px;\n  text-align: left;\n  font-size: 14px;\n  font-weight: bold;\n  color: #262626;\n  border-bottom: 1px solid #f0f0f0;\n  /* Shrink every column to its content's width instead of letting\n     auto table layout hand unused space to columns that don't need it. */\n  width: 1%;\n  white-space: nowrap;\n}\n\n/* Table data */\n.custom-table td {\n  padding: 8px 14px;\n  font-size: 13px;\n  color: #595959;\n  border-bottom: 1px solid #f0f0f0;\n  width: 1%;\n}\n\n/* Row hover effect */\n.custom-table tr:hover {\n  background-color: #e6f7ff;\n}\n\n/* Even row color */\n.custom-table tr:nth-child(even) {\n  background-color: #fcfcfc;\n}\n\n/* Pagination button */\n.page_link_item {\n  background-color: white;\n  border: 1px solid #d9d9d9;\n  padding: 5px 10px;\n  margin: 3px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n/* Pagination hover */\n.page_link_item:hover {\n  color: #1890ff;\n  border-color: #1890ff;\n}\n\n/* Disabled button */\n.page_link_item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Input box */\n.page_link_item input {\n  border: 1px solid #d9d9d9;\n  padding: 3px;\n  border-radius: 4px;\n}\n\n/* Select box */\n.page_link_item select {\n  border: 1px solid #d9d9d9;\n  padding: 3px;\n  border-radius: 4px;\n}\n\n/* Pagination margin */\n.my-3 {\n  margin-top: 15px;\n}\n\n/* Mobile screen */\n@media (max-width: 768px) {\n\n  .custom-table {\n    font-size: 12px;\n  }\n\n  .custom-table th,\n  .custom-table td {\n    padding: 8px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
